import React, {ReactNode} from "react";
import {LeaderboardDto} from "../../../core/models/dtos/leaderboard.dto";
import ContentKeys from "../../../core/utilities/contentKeys";
import {Images} from "../../../core/utilities/images";
import ContentKey from "../../ContentKey/ContentKey";
import "./Rankings.scss";

interface IProps {
  leaderboard: LeaderboardDto;
}

const Rankings = (props: IProps) => {

  const getRankingClass = (rank: number): string => {
    let className = 'ranking';
    if (rank === 1) {
      className += ' first';
    }
    if (rank === props.leaderboard.rank) {
      className += ' self';
    }
    return className;
  }

  const renderRanking = (rank: number, score: number): ReactNode => {
    return (
      <div
        key={`ranking-${rank}`}
        className={getRankingClass(rank)}
      >
        <img className="arrow" src={Images.chevron_right_orange} alt="arrow"/>
        <div className="rank-wrapper">
          {
            rank === 1 &&
            <img className="medal" src={Images.leaderboard_1} alt="medal"/>
          }
          {
            rank === 2 &&
            <img className="medal" src={Images.leaderboard_2} alt="medal"/>
          }
          {
            rank === 3 &&
            <img className="medal" src={Images.leaderboard_3} alt="medal"/>
          }
          <div className={`rank-box ${rank > 99 ? 'over-99' : ''}`}>
            {rank > 3 && <span className="rank link-medium">{rank}.</span>}
          </div>
        </div>
        <div className="score-wrapper">
          <span className="score text-medium">{score}</span>
        </div>
      </div>
    );
  }

  return (
    <div id="rankings">
      <div className="title">
        <ContentKey
          className="link-large"
          contentKey={ContentKeys.LEADERBOARD_TITLE}
        />
      </div>
      <div className="table">
        <div className="table-content">
          {renderRanking(1, props.leaderboard.score1)}
          {renderRanking(2, props.leaderboard.score2)}
          {renderRanking(3, props.leaderboard.score3)}
          {
            (props.leaderboard.rank > 3) &&
            <React.Fragment>
              {
                props.leaderboard.rank !== 4 &&
                <div className="d-flex justify-content-center">
                  <img className="point" src={Images.point} alt="point"/>
                </div>
              }
              {renderRanking(props.leaderboard.rank, props.leaderboard.score)}
            </React.Fragment>
          }
        </div>
      </div>
    </div>
  );
}

export default Rankings;
